import { render, staticRenderFns } from "./PiHoleStatsV6.vue?vue&type=template&id=8f1dde14&scoped=true"
import script from "./PiHoleStatsV6.vue?vue&type=script&lang=js"
export * from "./PiHoleStatsV6.vue?vue&type=script&lang=js"
import style0 from "./PiHoleStatsV6.vue?vue&type=style&index=0&id=8f1dde14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1dde14",
  null
  
)

export default component.exports